"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Session_module_1 = tslib_1.__importDefault(require("./modules/Session.module"));
const loadRentalModule = () => ({
    hasRouter: false,
    modules: [(0, Session_module_1.default)()],
});
exports.default = loadRentalModule;
